<template>
  <div class="sidebar" ref="sidebar">
    <el-menu :default-active="activeIndex" unique-opened @select="handleSelect" @open="handleOpen">
      <template v-for="item in menuList">
        <el-submenu :index="item.url || 'id'+item.id" :key="item.id" v-if="item.chirdMenuList">
          <template slot="title">
            <i :class="item.icon"/>
            {{item.menuName}}
          </template>
          <el-menu-item v-for="chird in item.chirdMenuList" :key="chird.id" :index="chird.url" :item="chird">
            {{chird.menuName}}
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="item.url" class="el-submenu__title" :key="item.id" :item="item" v-else>
          {{item.menuName}}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  nameL: 'Sidebar',
  props: {
    menuList: {
      type: Array
    }
  },
  data() {
    return {}
  },
  errorCaptured() {
    return false
  },
  computed: {
    activeIndex() {
      let path = this.$route.path
      if (this.$route.query.src && this.$route.path === '/iframe') {
        path = this.$route.query.src
      }
      return path || ''
    }
  },
  methods: {
    handleSelect(key, route, $e) {
      if ($e.$attrs.item.iframe) {
        // 判断是旧页面使用iframe打开
        if (document.querySelector('.iframe-box') && document.querySelector('.iframe-box').src.indexOf(key) != -1) {
          if (key && key.indexOf('admin/') < 0 && !key.startsWith('/poms')) {
            key = '/yunjiadmin/admin/' + key
          }
          let src = `${globalConfig.adminBasePath}/${key}?clearSearch=1`.replace('//', '/')
          document.querySelector('.iframe-box').src = `//${src}`
        }
        this.$router.push({
          path: '/iframe',
          query: {
            src: key,
            title: $e.$attrs.item.menuName,
            clearSearch: 1
          }
        })
      } else {
        this.$router.push({ path: key })
      }
    },
    handleOpen (id, openIndex = 0) {
      this.menuList.forEach((item, index) => {
        if (`id${item.id}` === id) {
          openIndex = index
        }
      })
        this.$refs.sidebar.scrollTop = openIndex * 48
    }
  }
}
</script>
<style src="./index.less" lang="less"></style>
